import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from "recharts";

const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function IncomeExpenseChart() {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchChartData = async () => {
      const user      = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = user?.company_id || "";
      if (!companyId) return;

      // ✅ company_id filter added
      const querySnapshot = await getDocs(
        query(collection(db, "financial_transactions"), where("company_id", "==", companyId))
      );

      const today = new Date();
      const last6Months = [];
      for (let i = 5; i >= 0; i--) {
        const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
        last6Months.push({ month: key, income: 0, expense: 0 });
      }

      const monthMap = {};
      last6Months.forEach((m) => { monthMap[m.month] = m; });

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const date = data.created_at?.toDate?.();
        if (!date) return;
        const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
        if (!monthMap[key]) return;
        if (data.type === "income")  monthMap[key].income  += Number(data.amount || 0);
        if (data.type === "expense") monthMap[key].expense += Number(data.amount || 0);
      });

      const finalData = last6Months.map((item) => ({
        ...monthMap[item.month],
        label: monthNames[parseInt(item.month.split("-")[1], 10) - 1],
      }));

      setChartData(finalData);
    };

    fetchChartData();
  }, []);

  return (
    <div style={{ width: "100%", height: 320 }}>
      <ResponsiveContainer>
        <BarChart data={chartData} barGap={10} barCategoryGap="20%">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="income"  fill="#3b82f6" radius={[6,6,0,0]} />
          <Bar dataKey="expense" fill="#ef4444" radius={[6,6,0,0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default IncomeExpenseChart;